import { invert } from 'lodash';
import { SHORTCUT_TYPE } from '../../../../config/constant/unityConstants';

export const SHORTCUT = {
  // basic
  OPEN_PROJECT: 'OPEN_PROJECT',
  SAVE_PROJECT: 'SAVE_PROJECT',
  SAVE_AS_NEW: 'SAVE_AS_NEW',
  QUIT_PROJECT: 'QUIT_PROJECT',
  UNDO: 'UNDO',
  REDO: 'REDO',
  DELETE: 'DELETE',
  DESELECT_OBJECTS: 'DESELECT_OBJECTS',

  // viewport
  ROTATE_VIEWPORT: 'ROTATE_VIEWPORT',
  PAN_VIEWPORT: 'PAN_VIEWPORT',
  ZOOM_IN_OUT: 'ZOOM_IN_OUT',
  SWITCH_VIEW_2D_3D: 'SWITCH_VIEW_2D_3D',
  TOP_VIEW: 'TOP_VIEW',
  FRONT_VIEW: 'FRONT_VIEW',
  LEFT_VIEW: 'LEFT_VIEW',
  RIGHT_VIEW: 'RIGHT_VIEW',
  BACK_VIEW: 'BACK_VIEW',

  // edit
  EDIT_PROPERTIES: 'EDIT_PROPERTIES',
  CHOOSE_TEXTURE: 'CHOOSE_TEXTURE',
  CHOOSE_MATERIAL: 'CHOOSE_MATERIAL',
  CHOOSE_COLOR: 'CHOOSE_COLOR',
  COPY_MATERIAL: 'COPY_MATERIAL',
  PASTE_MATERIAL: 'PASTE_MATERIAL', 
  SELECT_SAME_MATERIAL: 'SELECT_SAME_MATERIAL',
  DUPLICATE_SELECTED: 'DUPLICATE_SELECTED',
  REPLACE_SELECTED_PROP: 'REPLACE_SELECTED_PROP',
  PROJECT_IMAGES: 'PROJECT_IMAGES',
  RENDER_PROJECT: 'RENDER_PROJECT',
  PREVIEW_PROJECT: 'PREVIEW_PROJECT',

  // tools
  STYLE_ONLY: 'STYLE_ONLY',
  MOVE_SELECTED: 'MOVE_SELECTED',
  ROTATE_SELECTED: 'ROTATE_SELECTED',
  SCALE_SELECTED: 'SCALE_SELECTED',
  SNAP_SELECTED: 'SNAP_SELECTED',
  TOGGLE_ROTATION_SNAPPING: 'TOGGLE_ROTATION_SNAPPING',
  SWITCH_AXIS_GL: 'SWITCH_AXIS_GL',
  ACTIVATE_X_AXIS: 'ACTIVATE_X_AXIS',
  ACTIVATE_Y_AXIS: 'ACTIVATE_Y_AXIS',
  ACTIVATE_Z_AXIS: 'ACTIVATE_Z_AXIS',

  // selection
  SELECT: 'SELECT',
  DESELECT: 'DESELECT',
  DESELECT_ALL: 'DESELECT_ALL',
  SELECT_MULTIPLE: 'SELECT_MULTIPLE',
  OPEN_GROUP: 'OPEN_GROUP',
  SELECT_CHILD: 'SELECT_CHILD',
  DESELECT_CHILD: 'DESELECT_CHILD',
  SELECT_MULTIPLE_CHILD: 'SELECT_MULTIPLE_CHILD',  
  GROUP_SELECTED_OBJECT: 'GROUP_SELECTED_OBJECT',
  UN_GROUP_SELECTED_OBJECT: 'UN_GROUP_SELECTED_OBJECT',
  SELECT_PREVIOUS_SIBILING_CHILD: 'SELECT_PREVIOUS_SIBILING_CHILD',
  SELECT_NEXT_SIBILING_CHILD: 'SELECT_NEXT_SIBILING_CHILD',

  // view
  HIGHLIGHT_SELECTED: 'HIGHLIGHT_SELECTED',
  DIMENSIONS: 'DIMENSIONS',
  LIGHTS: 'LIGHTS',
  CAMERA_SAFE_FRAME: 'CAMERA_SAFE_FRAME',
  FOCUS_SELECTED: 'FOCUS_SELECTED',
  FOCUS_EVERYTHING: 'FOCUS_EVERYTHING',
  GRID: 'GRID',

  // hidden
  TOGGLE_DEBUGGER: 'TOGGLE_DEBUGGER',
};

export const basicShortcutsMap = {
  // [SHORTCUT.OPEN_PROJECT]: {  // Open Project - Remove for beta
  //   type: SHORTCUT_TYPE.BASIC,
  //   name: 'Open Project',
  //   keys: ['Ctrl', 'O'],
  //   editable: true,
  // },
  [SHORTCUT.SAVE_PROJECT]: {
    type: SHORTCUT_TYPE.BASIC,
    name: 'Save Project',
    keys: ['Ctrl', 'S'],
    editable: true,
  },
  [SHORTCUT.SAVE_AS_NEW]: {
    type: SHORTCUT_TYPE.BASIC,
    name: 'Save as new',
    keys: ['Shift', 'Ctrl', 'S'],
    editable: true,
  },
  [SHORTCUT.QUIT_PROJECT]: {
    type: SHORTCUT_TYPE.BASIC,
    name: 'Quit Project',
    keys: ['Ctrl', 'Q'],
    editable: true,
  },

  [SHORTCUT.UNDO]: {
    type: SHORTCUT_TYPE.BASIC,
    name: 'Undo',
    keys: ['Ctrl', 'Z'],
    editable: true,
  },
  [SHORTCUT.REDO]: {
    type: SHORTCUT_TYPE.BASIC,
    name: 'Redo',
    keys: ['Ctrl', 'Shift', 'Z'],
    editable: true,
  },
  [SHORTCUT.DELETE]: {
    type: SHORTCUT_TYPE.BASIC,
    name: 'Delete',
    keys: ['Delete'],
    editable: true,
  },

  [SHORTCUT.STYLE_ONLY]: {
    type: SHORTCUT_TYPE.BASIC,
    name: 'Style Only',
    keys: ['Q'],
    editable: true,
  },
};

export const viewportShortcutsMap = {
  [SHORTCUT.ROTATE_VIEWPORT]: {
    type: SHORTCUT_TYPE.VIEWPORT,
    name: 'Rotate viewport',
    keys: ['Click', 'Drag'],
    isHotkey: false,
    editable: false,
  },
  [SHORTCUT.PAN_VIEWPORT]: {
    type: SHORTCUT_TYPE.VIEWPORT,
    name: 'Pan viewport',
    keys: ['Right Click', 'Drag'],
    isHotkey: false,
    editable: false,
  },
  [SHORTCUT.ZOOM_IN_OUT]: {
    type: SHORTCUT_TYPE.VIEWPORT,
    name: 'Zoom in/out',
    keys: ['Scroll'],
    isHotkey: false,
    editable: false,
  },
  [SHORTCUT.FOCUS_SELECTED]: {
    type: SHORTCUT_TYPE.VIEWPORT,
    name: 'Focus selected',
    keys: ['F'],
    editable: true,
  },

  [SHORTCUT.SWITCH_VIEW_2D_3D]: {
    type: SHORTCUT_TYPE.VIEWPORT,
    name: 'Switch view (2D/3D)',
    keys: ['0'],
    editable: true,
  },
  [SHORTCUT.TOP_VIEW]: {
    type: SHORTCUT_TYPE.VIEWPORT,
    name: 'Top view',
    keys: ['1'],
    editable: true,
  },
  [SHORTCUT.FRONT_VIEW]: {
    type: SHORTCUT_TYPE.VIEWPORT,
    name: 'Front view',
    keys: ['2'],
    editable: true,
  },
  [SHORTCUT.LEFT_VIEW]: {
    type: SHORTCUT_TYPE.VIEWPORT,
    name: 'Left view',
    keys: ['3'],
    editable: true,
  },

  [SHORTCUT.RIGHT_VIEW]: {
    type: SHORTCUT_TYPE.VIEWPORT,
    name: 'Right view',
    keys: ['4'],
    editable: true,
  },
  [SHORTCUT.BACK_VIEW]: {
    type: SHORTCUT_TYPE.VIEWPORT,
    name: 'Back view',
    keys: ['5'],
    editable: true,
  },
  [SHORTCUT.DESELECT_OBJECTS]: {
    type: SHORTCUT_TYPE.BASIC,
    name: 'Deselect Objects',
    keys: ['esc'],
    editable: true,
  },
};

export const editShortcutsMap = {
  [SHORTCUT.EDIT_PROPERTIES]: {
    type: SHORTCUT_TYPE.EDIT,
    name: 'Edit properties',
    keys: ['P'],
    editable: true,
  },
  [SHORTCUT.CHOOSE_TEXTURE]: {
    type: SHORTCUT_TYPE.EDIT,
    name: 'Choose Texture',
    keys: ['T'],
    editable: true,
  },
  [SHORTCUT.CHOOSE_MATERIAL]: {
    type: SHORTCUT_TYPE.EDIT,
    name: 'Choose Material',
    keys: ['M'],
    editable: true,
  },
  [SHORTCUT.CHOOSE_COLOR]: {
    type: SHORTCUT_TYPE.EDIT,
    name: 'Choose Color',
    keys: ['C'],
    editable: true,
  },
  [SHORTCUT.COPY_MATERIAL]: {
    type: SHORTCUT_TYPE.EDIT,
    name: 'Copy material',
    keys: ['Ctrl', 'C'],
    editable: true,
  },
  [SHORTCUT.PASTE_MATERIAL]: {
    type: SHORTCUT_TYPE.EDIT,
    name: 'Paste material',
    keys: ['Ctrl', 'V'],
    editable: true,
  },
  [SHORTCUT.SELECT_SAME_MATERIAL]: {
    type: SHORTCUT_TYPE.SELECTION,
    name: 'Select Same Material',
    keys: ['Ctrl', 'M'],
    editable: true,
  },
  [SHORTCUT.DUPLICATE_SELECTED]: {
    type: SHORTCUT_TYPE.EDIT,
    name: 'Duplicate selected',
    keys: ['Ctrl', 'D'],
    editable: true,
  },
  [SHORTCUT.REPLACE_SELECTED_PROP]: {
    type: SHORTCUT_TYPE.EDIT,
    name: 'Replace selected prop',
    keys: ['Ctrl', 'H'],
    editable: true,
  },

  [SHORTCUT.PROJECT_IMAGES]: {
    type: SHORTCUT_TYPE.EDIT,
    name: 'Project Images',
    keys: ['Ctrl', 'I'],
    editable: true,
  },
  [SHORTCUT.RENDER_PROJECT]: {
    type: SHORTCUT_TYPE.EDIT,
    name: 'Render project',
    keys: ['Ctrl', 'R'],
    editable: true,
  },
  [SHORTCUT.PREVIEW_PROJECT]: {
    type: SHORTCUT_TYPE.EDIT,
    name: 'Preview project',
    keys: ['Ctrl', 'P'],
    editable: true,
  },  
};

export const toolsShortcutsMap = {
  [SHORTCUT.MOVE_SELECTED]: {
    type: SHORTCUT_TYPE.TOOLS,
    name: 'Move selected',
    keys: ['W'],
    editable: true,
  },
  [SHORTCUT.ROTATE_SELECTED]: {
    type: SHORTCUT_TYPE.TOOLS,
    name: 'Rotate selected',
    keys: ['E'],
    editable: true,
  },
  [SHORTCUT.SCALE_SELECTED]: {
    type: SHORTCUT_TYPE.TOOLS,
    name: 'Scale selected',
    keys: ['R'],
    editable: true,
  },

  [SHORTCUT.SNAP_SELECTED]: {
    type: SHORTCUT_TYPE.TOOLS,
    name: 'Snap Selected',
    keys: ['S', 'Hover'], // + mouse move
    isHotkey: false,
    editable: true,
    maxEditableKeys: 2,
  },
  [SHORTCUT.TOGGLE_ROTATION_SNAPPING]: {
    type: SHORTCUT_TYPE.TOOLS,
    name: 'Rotation snapping',
    keys: ['I'],
    editable: true,
  },
  [SHORTCUT.SWITCH_AXIS_GL]: {
    type: SHORTCUT_TYPE.TOOLS,
    name: 'Switch Axis (Global/Local)',
    keys: ['G'],
    editable: true,
  },

  [SHORTCUT.ACTIVATE_X_AXIS]: {
    type: SHORTCUT_TYPE.TOOLS,
    name: 'Activate x axis only',
    keys: ['X'],
    editable: true,
  },
  [SHORTCUT.ACTIVATE_Y_AXIS]: {
    type: SHORTCUT_TYPE.TOOLS,
    name: 'Activate y axis only',
    keys: ['Y'],
    editable: true,
  },
  [SHORTCUT.ACTIVATE_Z_AXIS]: {
    type: SHORTCUT_TYPE.TOOLS,
    name: 'Activate z axis only',
    keys: ['Z'],
    editable: true,
  },
};

export const selectionShortcutsMap = {
  [SHORTCUT.SELECT]: {
    type: SHORTCUT_TYPE.SELECTION,
    name: 'Select',
    keys: ['Click'],
    isHotkey: false,
    editable: false,
  },
  [SHORTCUT.DESELECT]: {
    type: SHORTCUT_TYPE.SELECTION,
    name: 'Deselect',
    keys: ['Alt', 'Click'], // + click
    isHotkey: false,
    editable: true,
    maxEditableKeys: 2,
  },
  [SHORTCUT.DESELECT_ALL]: {
    type: SHORTCUT_TYPE.SELECTION,
    name: 'Deselect All',
    keys: ['esc'], // + click
    isHotkey: false,
    editable: true,
  },
  [SHORTCUT.SELECT_MULTIPLE]: {
    type: SHORTCUT_TYPE.SELECTION,
    name: 'Select multiple',
    keys: ['Shift', 'Click'],
    editable: true,
    maxEditableKeys: 2,
  },
  [SHORTCUT.OPEN_GROUP]: {
    type: SHORTCUT_TYPE.SELECTION,
    name: 'Open group',
    keys: ['Double Click'],
    editable: false,
  },

  [SHORTCUT.SELECT_CHILD]: {
    type: SHORTCUT_TYPE.SELECTION,
    name: 'Select child',
    keys: ['Ctrl', 'Click'],
    editable: true,
    maxEditableKeys: 2,
  },
  [SHORTCUT.DESELECT_CHILD]: {
    type: SHORTCUT_TYPE.SELECTION,
    name: 'Deselect child',
    keys: ['Alt', 'Ctrl', 'Click'],
    editable: true,
    maxEditableKeys: 2,
  },
  [SHORTCUT.SELECT_MULTIPLE_CHILD]: {
    type: SHORTCUT_TYPE.SELECTION,
    name: 'Select multiple child',
    keys: ['Shift', 'Ctrl', 'Click'],
    editable: true,
    maxEditableKeys: 2,
  },  
  [SHORTCUT.GROUP_SELECTED_OBJECT]: {
    type: SHORTCUT_TYPE.GROUP_SELECTED_OBJECT,
    name: 'Exit group',
    keys: ['left'],
    editable: true,
  },
  [SHORTCUT.UN_GROUP_SELECTED_OBJECT]: {
    type: SHORTCUT_TYPE.UN_GROUP_SELECTED_OBJECT,
    name: 'Enter Group',
    keys: ['right'],
    editable: true,
  },
  [SHORTCUT.SELECT_PREVIOUS_SIBILING_CHILD]: {
    type: SHORTCUT_TYPE.SELECT_PREVIOUS_SIBILING_CHILD,
    name: 'Select previous child',
    keys: ['up'],
    editable: true,
  },
  [SHORTCUT.SELECT_NEXT_SIBILING_CHILD]: {
    type: SHORTCUT_TYPE.SELECT_NEXT_SIBILING_CHILD,
    name: 'Select next child',
    keys: ['down'],
    editable: true,
  },
};

export const viewShortcutsMap = {
  [SHORTCUT.HIGHLIGHT_SELECTED]: {
    type: SHORTCUT_TYPE.VIEW,
    name: 'Highlight outlines',
    nameSuffix: '(On/Off)',
    keys: ['Alt', 'H'],
    editable: true,
  },
  [SHORTCUT.DIMENSIONS]: {
    type: SHORTCUT_TYPE.VIEW,
    name: 'Dimensions',
    nameSuffix: '(On/Off)',
    keys: ['Alt', 'D'],
    editable: true,
  },
  [SHORTCUT.LIGHTS]: {
    type: SHORTCUT_TYPE.VIEW,
    name: 'Lights',
    nameSuffix: '(Hide/Unhide)',
    keys: ['Alt', 'L'],
    editable: true,
  },
  [SHORTCUT.CAMERA_SAFE_FRAME]: {
    type: SHORTCUT_TYPE.VIEW,
    name: 'Camera Frame',
    keys: ['Alt', 'F'],
    editable: true,
  },

  [SHORTCUT.FOCUS_EVERYTHING]: {
    type: SHORTCUT_TYPE.VIEW,
    name: 'Focus everything',
    keys: ['Shift', 'F'],
    editable: true,
  },

  [SHORTCUT.GRID]: {
    type: SHORTCUT_TYPE.VIEW,
    name: 'Grid',
    nameSuffix: '(On/Off)',
    keys: ['Alt', 'G'],
    editable: true,
  },
};

const hiddenShortcutsMap = {
  [SHORTCUT.TOGGLE_DEBUGGER]: {
    name: 'Toggle debugger',
    keys: ['Ctrl', 'Shift', 'D'],
    editable: false,
  },
};

export const curatorShortcutsMap = {
  ...basicShortcutsMap,
  ...viewportShortcutsMap,
  ...editShortcutsMap,
  ...toolsShortcutsMap,
  ...selectionShortcutsMap,
  ...viewShortcutsMap,
  ...hiddenShortcutsMap,
};

export const curatorShortcutsSections = {
  [SHORTCUT_TYPE.BASIC]: {
    left: [
      // SHORTCUT.OPEN_PROJECT,  // Open Project - Remove for beta
      SHORTCUT.SAVE_PROJECT,
      SHORTCUT.SAVE_AS_NEW,
      SHORTCUT.QUIT_PROJECT,
    ],
    middle: [SHORTCUT.UNDO, SHORTCUT.REDO, SHORTCUT.DELETE],
    right: [SHORTCUT.STYLE_ONLY],
  },
  [SHORTCUT_TYPE.VIEWPORT]: {
    left: [
      SHORTCUT.ROTATE_VIEWPORT,
      SHORTCUT.PAN_VIEWPORT,
      SHORTCUT.ZOOM_IN_OUT,
      SHORTCUT.FOCUS_SELECTED,
    ],
    middle: [
      SHORTCUT.SWITCH_VIEW_2D_3D,
      SHORTCUT.TOP_VIEW,
      SHORTCUT.FRONT_VIEW,
      SHORTCUT.LEFT_VIEW,
    ],
    right: [SHORTCUT.RIGHT_VIEW, SHORTCUT.BACK_VIEW],
  },
  [SHORTCUT_TYPE.EDIT]: {
    left: [
      SHORTCUT.EDIT_PROPERTIES,
      SHORTCUT.CHOOSE_TEXTURE,
      SHORTCUT.CHOOSE_MATERIAL,
      SHORTCUT.CHOOSE_COLOR,
    ],
    middle: [
      SHORTCUT.COPY_MATERIAL,
      SHORTCUT.PASTE_MATERIAL, 
      SHORTCUT.SELECT_SAME_MATERIAL,     
      SHORTCUT.DUPLICATE_SELECTED,
      SHORTCUT.REPLACE_SELECTED_PROP,      
    ],
    right: [SHORTCUT.PROJECT_IMAGES, SHORTCUT.RENDER_PROJECT, SHORTCUT.PREVIEW_PROJECT],
  },
  [SHORTCUT_TYPE.TOOLS]: {
    left: [
      SHORTCUT.STYLE_ONLY,
      SHORTCUT.MOVE_SELECTED,
      SHORTCUT.ROTATE_SELECTED,
      SHORTCUT.SCALE_SELECTED,
    ],
    middle: [SHORTCUT.TOGGLE_ROTATION_SNAPPING, SHORTCUT.SNAP_SELECTED, SHORTCUT.SWITCH_AXIS_GL],
    right: [SHORTCUT.ACTIVATE_X_AXIS, SHORTCUT.ACTIVATE_Y_AXIS, SHORTCUT.ACTIVATE_Z_AXIS],
  },
  [SHORTCUT_TYPE.SELECTION]: {
    left: [
      SHORTCUT.SELECT,
      SHORTCUT.DESELECT,
      SHORTCUT.DESELECT_ALL,
      SHORTCUT.SELECT_MULTIPLE,
      SHORTCUT.OPEN_GROUP,
      SHORTCUT.SELECT_CHILD,
    ],
    middle: [
      SHORTCUT.DESELECT_CHILD,
      SHORTCUT.SELECT_MULTIPLE_CHILD,      
      SHORTCUT.UN_GROUP_SELECTED_OBJECT,
      SHORTCUT.GROUP_SELECTED_OBJECT,
      SHORTCUT.SELECT_PREVIOUS_SIBILING_CHILD,
      SHORTCUT.SELECT_NEXT_SIBILING_CHILD,
    ],
    right: [],
  },
  [SHORTCUT_TYPE.VIEW]: {
    left: [
      SHORTCUT.HIGHLIGHT_SELECTED,
      SHORTCUT.DIMENSIONS,
      SHORTCUT.LIGHTS,
      SHORTCUT.CAMERA_SAFE_FRAME,
    ],
    middle: [SHORTCUT.FOCUS_SELECTED, SHORTCUT.FOCUS_EVERYTHING, SHORTCUT.GRID],
    right: [],
  },
};

export const mattressShortcutsSections = {
  [SHORTCUT_TYPE.BASIC]: {
    left: [
      SHORTCUT.SAVE_PROJECT,
      SHORTCUT.SAVE_AS_NEW,
      SHORTCUT.QUIT_PROJECT,
    ],
    middle: [
      SHORTCUT.UNDO,
      SHORTCUT.REDO,
      SHORTCUT.DELETE,
    ],
    right: [],
  },
  [SHORTCUT_TYPE.VIEWPORT]: {
    left: [
      SHORTCUT.ROTATE_VIEWPORT,
      SHORTCUT.PAN_VIEWPORT,
      SHORTCUT.ZOOM_IN_OUT,
      SHORTCUT.FOCUS_SELECTED,
    ],
    middle: [],
    right: [],
  },
  [SHORTCUT_TYPE.EDIT]: {
    left: [
      SHORTCUT.EDIT_PROPERTIES,
      SHORTCUT.CHOOSE_TEXTURE,
      SHORTCUT.CHOOSE_MATERIAL,
      SHORTCUT.CHOOSE_COLOR,
    ],
    middle: [SHORTCUT.PROJECT_IMAGES, SHORTCUT.RENDER_PROJECT, SHORTCUT.PREVIEW_PROJECT],
    right: [SHORTCUT.COPY_MATERIAL, SHORTCUT.PASTE_MATERIAL],
  },
  [SHORTCUT_TYPE.SELECTION]: {
    left: [SHORTCUT.SELECT, SHORTCUT.DESELECT, SHORTCUT.DESELECT_ALL, SHORTCUT.SELECT_MULTIPLE],
    middle: [],
    right: [],
  },
};

// https://github.com/VladimirBlagojevic/keycodes-map/blob/master/index.js
export const invertedKeys = {
  // Numbers and letters
  0: 48,
  1: 49,
  2: 50,
  3: 51,
  4: 52,
  5: 53,
  6: 54,
  7: 55,
  8: 56,
  9: 57,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90,

  // Punctuations keys in US layout
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222,

  // Modifier keys
  Shift: 16,
  Ctrl: 17,
  Alt: 18,
  // capsLock: 20,

  // Control keys
  Tab: 9,
  Enter: 13,
  Pause: 19,
  escape: 27,
  Space: 32,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  // printScreen: 44,
  insert: 45,
  Del: 46,
  Delete: 8,
  // contextMenu: 93,
  // scrollLock: 145,

  // Function keys
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  F13: 124,
  F14: 125,
  F15: 126,
  F16: 127,
  F17: 128,
  F18: 129,
  F19: 130,
  F20: 131,
  F21: 132,
  F22: 133,
  F23: 134,
  F24: 135,

  // custom events
  Click: 'Click',
  Hover: 'Hover',

  // Numpad keys
  // numpad0: 96,
  // numpad1: 97,
  // numpad2: 98,
  // numpad3: 99,
  // numpad4: 100,
  // numpad5: 101,
  // numpad6: 102,
  // numpad7: 103,
  // numpad8: 104,
  // numpad9: 105,
  // numpadMultiply: 106,
  // numpadAdd: 107,
  // numpadSubtract: 109,
  // numpadDecimal: 110,
  // numpadDivide: 111,
  // numLock: 144,
  // numpadComma: 194,
  // numpadEqual: 12
};

export const KEYS = invert(invertedKeys);
